var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWemoveWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1268,
    height: 291,
    viewBox: "0 0 1268 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2240_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6449 80.9619L141.5 20.4238L246.355 80.9619V202.038L141.5 262.576L36.6449 202.038V80.9619Z",
    stroke: "white",
    strokeWidth: 35.375,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.791 256.675V136.195L39.4883 85.5586",
    stroke: "white",
    strokeWidth: 35.375,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.791 138.209L243.511 78.9766",
    stroke: "white",
    strokeWidth: 35.375,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.962 216.573L316 66.4268H350.677L375.531 170.752H376.777L404.196 66.4268H433.889L461.235 170.972H462.554L487.408 66.4268H522.085L479.123 216.573H448.185L419.592 118.406H418.419L389.9 216.573H358.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.076 216.573V66.4268H640.249V92.5998H570.82V128.377H635.043V154.55H570.82V190.4H640.542V216.573H539.076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.487 66.4268H704.636L745.985 167.307H747.745L789.094 66.4268H828.243V216.573H797.452V118.846H796.205L757.349 215.84H736.381L697.525 118.48H696.279V216.573H665.487V66.4268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.375 141.5C992.375 157.874 989.271 171.803 983.064 183.289C976.905 194.775 968.499 203.548 957.844 209.609C947.238 215.62 935.312 218.626 922.067 218.626C908.724 218.626 896.749 215.596 886.143 209.535C875.537 203.475 867.155 194.702 860.996 183.216C854.838 171.73 851.759 157.825 851.759 141.5C851.759 125.127 854.838 111.197 860.996 99.7113C867.155 88.2254 875.537 79.4767 886.143 73.4649C896.749 67.4043 908.724 64.374 922.067 64.374C935.312 64.374 947.238 67.4043 957.844 73.4649C968.499 79.4767 976.905 88.2254 983.064 99.7113C989.271 111.197 992.375 125.127 992.375 141.5ZM960.19 141.5C960.19 130.894 958.601 121.95 955.424 114.667C952.296 107.385 947.873 101.862 942.155 98.0984C936.436 94.3349 929.74 92.4532 922.067 92.4532C914.393 92.4532 907.697 94.3349 901.979 98.0984C896.26 101.862 891.813 107.385 888.636 114.667C885.508 121.95 883.944 130.894 883.944 141.5C883.944 152.106 885.508 161.05 888.636 168.333C891.813 175.615 896.26 181.138 901.979 184.902C907.697 188.665 914.393 190.547 922.067 190.547C929.74 190.547 936.436 188.665 942.155 184.902C947.873 181.138 952.296 175.615 955.424 168.333C958.601 161.05 960.19 152.106 960.19 141.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.55 66.4268L1070.84 180.503H1072.23L1108.6 66.4268H1143.79L1092.03 216.573H1051.12L999.284 66.4268H1034.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.86 216.573V66.4268H1263.03V92.5998H1193.6V128.377H1257.83V154.55H1193.6V190.4H1263.32V216.573H1161.86Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2240_35",
    x: -4,
    y: 0,
    width: 1271.32,
    height: 291,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2240_35"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2240_35",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWemoveWhite);
export default __webpack_public_path__ + "static/media/wemove-white.642fc057c8681e6cdbf9f0df8bbfcd53.svg";
export { ForwardRef as ReactComponent };